import jwtDecode from 'jwt-decode'

interface JwtPayload {
  exp?: number
}

export const getJwtExpirationTime = (token: string): number | null => {
  try {
    const { exp } = jwtDecode<JwtPayload>(token)

    if (!exp) return null

    return exp * 1000
  } catch {
    return 0
  }
}

export const isJwtExpired = (token: string): boolean => {
  const expirationTime = getJwtExpirationTime(token)

  if (!expirationTime) return false

  return Date.now() >= expirationTime
}
